import * as actions from "../../../actions/inventory/report";

const initialState = {
  loading: false,
  items: [],
  pages: null,
  filter: []
};

const reducer = function(state = initialState, { type, payload }) {
  switch (type) {
    case actions.GET_INVENTORY: {
      return {
        ...state,
        loading: true
      };
    }
    case actions.GET_INVENTORY_FAILED: {
      return {
        ...state,
        loading: false
      };
    }
    case actions.GET_INVENTORY_SUCCESS: {
      return {
        ...state,
        items: payload ? payload : [],
        loading: false
      };
    }
    case actions.CLEAR_ITEMS: {
      return {
        ...state,
        items: []
      };
    }
    case actions.SET_VALUE: {
      return {
        ...state,
        ...payload
      };
    }
    default: {
      return state;
    }
  }
};

export default reducer;
